import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { Router } from '@angular/router';
import { School } from '../school';

@Component({
  selector: 'app-online-courses',
  templateUrl: './online-courses.component.html',
  styleUrls: ['./online-courses.component.css']
})
export class OnlineCoursesComponent implements OnInit {

  schools: School[] = [];

  searchTerm = "";
  searchOption = "name";

  constructor(
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.httpService.getOnlineSchools().subscribe(res => {
      this.schools = res.reverse();
    });
  }

  editSchool(id: number){
    this.router.navigateByUrl("/management/edit-school/" + id);
  }


  

}
